import Pagination from '@mui/material/Pagination';
import styled from '@emotion/styled';
import { colors } from '../tokens';

/**
 * StyledPagination — pre-styled MUI Pagination with centralized selected-state colors.
 * Replaces the repeated inline sx pattern found in:
 *   - CryptoPricesPagination.js
 *   - Messages/Events.jsx
 *   - Messages/General.js
 *   - Messages/News.jsx
 *   - Transactions/Transactions.js
 *
 * Pass all standard MUI Pagination props as normal.
 */
const StyledPagination = styled(Pagination)({
  '& .MuiPaginationItem-circular': {
    backgroundColor: colors.background.paper,
  },
  '& .Mui-selected': {
    backgroundColor: `${colors.primary.main} !important`,
    color: colors.primary.contrastText,
  },
  '& .Mui-selected:hover': {
    backgroundColor: `${colors.primary.main} !important`,
    color: colors.primary.contrastText,
  },
});

export default StyledPagination;
